import React, { Component } from 'react';
import { defineMessages, FormattedMessage,   injectIntl } from 'react-intl';
import { Input, Tag, Icon, Popover } from 'antd';
import { TweenOneGroup } from 'rc-tween-one';
import isValidKeyText, { maxKeyTextCount } from '../utils/isValidKeyText';
import { notiFormForError } from './notificationForm';
import packKeytextGuide from '../img/upload/packKeytextGuide.svg'

import '../styles/PackageInfo.css';

const messages = defineMessages({
  notValideKeyText:{
    id:'PackageInfo.noti.languageSelection.input.keyText.notValid',
    defaultMessage:'Pack keyword can be entered up to 10 in English and numbers. The space between keywords is allowed up to 2 times.'
  },
})

const tagTextExamples = ["Rabbit", "Hamster", "Fun", "Hilarious", "Tears", "Lol"];

const packKeyTextGuideContent = (
  <div className="pack-keytext-popover-guide-box">
    <div className="pack-keytext-popover-guide-title">Example</div>
    <div style={{display:'flex'}}>
      <img src={packKeytextGuide} alt="keytext-guide-example" style={{width:'72px', height:'72px'}} />
      <div style={{marginLeft:'8px'}}>
        {
          tagTextExamples.map(tagText => (
            <span className="pack-keytext-popover-guide-tag-box" key={tagText}>
              <span className="pack-keytext-popover-guide-tag"># {tagText}</span>
            </span>
          ))
        }
      </div>
    </div>
  </div>
)

export const PackKeyTextGuide = () => (
  <Popover content={packKeyTextGuideContent}>
    <span style={{color:'#a202ff', marginLeft:'8px', cursor: 'pointer'}}>
      <Icon type="question-circle" style={{width : 16 }}/>
    </span>
  </Popover>
)

class PackKeyTextForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyTextInputVisible: false,
      keyTextInputValue: '',
    }
  }

  showKeyTextInput = () => {
    this.setState({
      keyTextInputVisible: true
    }, () => {
      setTimeout(() => {
        this.keyTextInput && this.keyTextInput.focus()
      }, 100);
    });
  }

  saveKeyTextInputRef = input => { this.keyTextInput = input }

  handleKeyTextInputChange = e => { this.setState({ keyTextInputValue: e.target.value }) }

  addKeyTextInput = () => {
    const { keyTextInputValue } = this.state;
    let { keyTexts } = this.props;
    const { locale, formatMessage } = this.props.intl;

    const inputValue = keyTextInputValue.trim().toLowerCase();

    if (inputValue !== '') {
      if (isValidKeyText(inputValue, keyTexts.length)) {
        keyTexts = [...keyTexts.filter(keyText => keyText !== inputValue), inputValue];
        this.props.setKeyTexts(keyTexts);
      } else {
        notiFormForError(locale, formatMessage(messages.notValideKeyText));
        return;
      }
    }

    this.setState({
      keyTextInputVisible: false,
      keyTextInputValue: '',
    });
  }

  removeKeyTextTag = text => {
    const { keyTexts } = this.props;
    const updatedKeyTexts = keyTexts.filter(keyText => keyText !== text);
    this.props.setKeyTexts(updatedKeyTexts);
  }

  generateKeyTextTag = keyText => {
    const tagElem = (
      <Tag
        className="pack-keytext-tag"
        closable={true}
        onClose={e => {
          e.preventDefault();
          this.removeKeyTextTag(keyText);
        }}
      >
       {`# ${keyText}`}
      </Tag>
    )

    return (
      <span key={keyText} className='pack-keytext-tag-box'>
        {tagElem}
      </span>
    )
  }

  render() {
    const { keyTextInputValue, keyTextInputVisible } = this.state;
    const { styles } = this.props;
    const keyTextTags = this.props.keyTexts.map(this.generateKeyTextTag)

    return (
      <div className="pack-keytext-input-box" style={styles ? styles : {}}>
        <TweenOneGroup
          enter={{
            scale: 0.8,
            opacity: 0,
            type: 'from',
            duration: 100,
            onComplete: e => {
              e.target.style = '';
            },
          }}
          leave={{ opacity: 0, width: 0, scale: 0, duration: 200}}
          appear={false}
          style={{ margin: '8px 0px 0px 8px' }}
        >
          <span key="keyTextInputHolder" style={{ display: 'inline-block', marginBottom: '8px' }}>
            <Input
              ref={ this.saveKeyTextInputRef }
              hidden={ !keyTextInputVisible }
              type="text"
              size="small"
              style={{ width: 134, height: 24, boxSizing:'border-box', marginRight: '8px' }}
              value={ keyTextInputValue }
              onChange={ this.handleKeyTextInputChange }
              onBlur={ this.addKeyTextInput }
              onPressEnter={ this.addKeyTextInput }
            />
            <Tag
              hidden={ keyTextInputVisible }
              onClick={ this.showKeyTextInput }
              style={{
                display: 'flex',
                alignItems: 'center',
                background: '#fff',
                borderStyle:'dashed',
                color: 'rgba(0, 0, 0, 0.6)',
                height: 24
              }}
            >
              <span style={{color: 'rgba(0, 0, 0, 0.38)', marginRight:'4px'}}>
                <Icon type="plus" />
              </span>
                <FormattedMessage 
                  id="package.input.keyword.placeholder"
                  defaultMessage="Enter the keyword"
              />
            </Tag>
          </span>
          { keyTextTags }
          <div className="pack-keytext-input-length">
            {`${keyTextTags.length}/${maxKeyTextCount}`}
          </div>
        </TweenOneGroup>       
      </div>
    );
  }
}

  
PackKeyTextForm = injectIntl(PackKeyTextForm);

export default PackKeyTextForm;